export const setRedirect = (path) => (dispatch, getState) => {
  dispatch({
    type: "SET_REDIRECT",
    payload: path,
  });
};

export const clearRedirect = () => (dispatch, getState) => {
  dispatch({
    type: "CLEAR_REDIRECT",
  });
};
